// SectionTabs.jsx
import { useSelector } from 'react-redux';
import SectionRenderer from '../../../components/SectionRenderer';
import ScrollLTR from '../../../components/ui/scrollLTR/ScrollLTR';
import classes from './SectionTabs.module.css';
import { isIdentified } from '../../../ui/builders/utils';

const SectionTabs = ({ tabs, scrollRef, onScrollFunc }) => {

  const authState = useSelector(state => state.auth);
  const identified = isIdentified(authState);
  
  return (
    <div className={classes.content}>
      <ScrollLTR downDropStyle={classes.downDropStyle} dropClass={`${classes.dropClass} ${!identified ? classes.unidentified : ''}`} ref={scrollRef} onScrollFunc={onScrollFunc}>
        {tabs.map((tab) => (
          <div key={tab.id} className={classes.tabContent}>
            {tab.sections?.map(section => (
              <div key={section.id} id={section.anchorId}>
                <SectionRenderer section={section} />
              </div>
            ))}
          </div>
        ))}
      </ScrollLTR>
    </div>
  );
};


export default SectionTabs;
